<template>
    <main class="main-content">
        <div class="about-section">
            <!-- Added About Timbrely markdown content here -->
            <section class="about-timbrely">
                <div style="width: 100%;display:flex;justify-content: center;padding:2rem;">
                    <img src="@/assets/icons/iconApp.svg" alt="App" class="app-svg" />
                </div>
                <h1>About Timbrely</h1>
                <p>
                    At Timbrely, we refuse to be "just another voice app with few innovation"
                    We're redefining how people interact with voice. Built on cutting-edge TTS and LLM technology and
                    powered by a modern tech stack, our mission is simple: to give you the most user-friendly and
                    interactive voice application on the market.
                </p>
                <h2>Voice, Your Way</h2>
                <ul>
                    <li>Find the perfect voice using natural-language search — no technical jargon, just describe what
                        you want.</li>
                    <li>Project-based TTS helps you organize and scale your work with ease.</li>
                    <li>Design your own voice to match your unique use case, whether it's narration, teaching,
                        podcasting, or storytelling.</li>
                </ul>
                <h2>English First, Cost-Smart</h2>
                <p>
                    We focus exclusively on English, so you don't pay for what you don't need. By cutting out the long
                    tail of languages, we help you achieve top-tier quality at a fraction of the cost.
                </p>
                <h2>Innovation That Works for You</h2>
                <p>We go beyond static demos:</p>
                <ul>
                    <li>LLM-powered voice search helps you discover voices that fit your intent.</li>
                    <li>Text-based voice preview means you test voices on your own content, so you know exactly how it
                        sounds before committing.</li>
                </ul>
                <h2>Constantly Evolving</h2>
                <p>
                    We release new features designed around your needs. Your feedback fuels our roadmap — ensuring we're
                    always solving real problems and keeping your requirements at the heart of what we do.
                </p>
                <h2>🤝 Built on Relationships</h2>
                <p>
                    We believe in long-term partnerships. That's why the more you use Timbrely, the more you save. Our
                    loyalty discounts make scaling with us not just powerful, but sustainable.
                    Timbrely isn't just about technology — it's about empowering you with the right voice, at the right
                    time, for the right purpose.
                </p>
            </section>

            <!-- <section class="about-timbrely">
                <h3>Transparency & Attribution</h3>
                <p>
                    For full open-source license disclosures used by this website, view the <a
                        href="/AttributionsWebsite.txt" target="_blank" rel="noopener">website's attribution file</a>.
                    For full open-source license from models and related services disclosures used by this website, view
                    the
                    <a href="/AttributionsModels.txt" target="_blank" rel="noopener">models' attribution file</a>.
                </p>
            </section> -->

            <div class="policy-links">
                <a href="/TOU.html" target="_blank" rel="noopener">Terms of Use</a>
                <a href="/PrivacyPolicy.html" target="_blank" rel="noopener">Privacy Policy</a>
                <a href="/PaymentPolicy.html" target="_blank" rel="noopener">Payment Policy</a>
            </div>
            <!-- <p class="visible-credit">
                Icons by <a href="https://fontawesome.com" target="_blank" rel="noopener">Font Awesome</a> — CC BY 4.0.
            </p> -->
        </div>
    </main>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
    name: 'AboutView',
    setup() {
        const safeHtml = ref('');
        const touContent = ref('');
        const privacyContent = ref('');
        const paymentContent = ref('');

        onMounted(async () => {

            touContent.value = await (await fetch('/TOU.html')).text();
            privacyContent.value = await (await fetch('/PrivacyPolicy.html')).text();
            paymentContent.value = await (await fetch('/PaymentPolicy.html')).text();
        });

        return {
            safeHtml,
            touContent,
            privacyContent,
            paymentContent
        };
    }
};
</script>

<style scoped>
.main-content {
    margin: 1rem;
    margin-top: 2rem;
    margin-left: 2rem;
    margin-right: 2rem;
}

.about-section {
    display: grid;
    gap: 16px;
    text-align: left;
    justify-items: center;
}

.app-svg {
    width: 50px;
    height: 50px;
    display: block;
    transition: filter 0.3s, color 0.3s;
    filter: var(--purple-filter)
}

.about-core {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    text-align: center;
}

.visible-credit {
    margin-top: 8px;
    font-size: 12px;
    color: var(--text-secondary, #6b7280);
    text-align: center;
}

.about-section h2 {
    text-align: left;
}

.tou-content {
    height: 400px;
    border: 1px solid #ccc;
    background-color: white;
    font-family: Arial, sans-serif;
    font-size: 14px;
    padding: 8px;
    overflow: auto;
    white-space: pre-wrap;
    text-align: left;
    max-width: 800px;
}

.privacy-content {
    height: 400px;
    border: 1px solid #ccc;
    background-color: white;
    font-family: Arial, sans-serif;
    font-size: 14px;
    padding: 8px;
    overflow: auto;
    white-space: pre-wrap;
    text-align: left;
    max-width: 800px;
}

.payment-content {
    height: 400px;
    border: 1px solid #ccc;
    background-color: white;
    font-family: Arial, sans-serif;
    font-size: 14px;
    padding: 8px;
    overflow: auto;
    white-space: pre-wrap;
    text-align: left;
    max-width: 800px;
}

.about-timbrely {
    margin-bottom: 2rem;
    text-align: center;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    align-items: left;
}

.about-timbrely h1 {
    font-size: 24px;
    margin-bottom: 1rem;
}

.about-timbrely h2 {
    font-size: 20px;
    margin: 1rem 0;
}

.about-timbrely ul {
    list-style-type: disc;
    padding-left: 1.5rem;
    text-align: left;
    margin: 0.5rem 0;
}

.about-timbrely p {
    margin: 0.5rem 0;
    text-align: left;
}

.policy-links {
    margin: 1rem 0 0.5rem 0;
    text-align: center;
    font-size: 12px;
    display: flex;
    justify-content: center;
    gap: 1.5rem;
}

.policy-links a {
    color: var(--text-secondary, #6b7280);
    transition: color 0.2s;
}

.policy-links a:hover {
    color: var(--primary, #7c3aed);
}
</style>
